import type { OrgStatus } from '@carcheck/shared';
import Chip, { type ChipProps } from '@mui/material/Chip';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/** active → green, suspended → amber, terminated → grey (the mockup's badges). */
const COLOR: Record<OrgStatus, ChipProps['color']> = {
  active: 'success',
  suspended: 'warning',
  terminated: 'default',
};

export const CompanyStatusBadge = ({ status }: { status: OrgStatus }): ReactElement => {
  const { t } = useTranslation();
  return <Chip size="small" color={COLOR[status]} label={t(`companies.status.${status}`)} />;
};
